interface RouteMessages {
  [key: string]: string
}

interface RouteConfig {
  default: string
  routes: RouteMessages
}

export const routesWindowTitleConfig: { [key: string]: RouteConfig } = {
  register: {
    default: 'Register - Alegra Software Contable',
    routes: {
      register: 'Register - Regístrate en {productName}',
      'register-pos': 'Register - Regístrate en Alegra Sistema POS',
      'register-tpv': 'Register - Regístrate en Alegra TPV',
      'register-pv': 'Register - Regístrate en Alegra Sistema Punto de Venta',
      'register-by-country': 'Register - Regístrate en {productName}',
      'register-costa-rica': 'Register - Regístrate en {productName}',
      'register-payroll': 'Register - Regístrate en {productName}',
      'register-payroll-by-country': 'Register - Regístrate en {productName}',
    },
  },
  login: {
    default: 'Login - Alegra Software Contable',
    routes: {
      login: 'Login - Ingreso a {productName}',
      'login-by-country': 'Login - Ingreso a {productName}',
      'login-payroll': 'Login - Ingreso a {productName}',
      'login-payroll-by-country': 'Login - Ingreso a {productName}',
      'magic-link-login': 'Login - Ingreso a {productName}',
      'login-pos': 'Login - Ingreso a Alegra Sistema POS',
      'login-tpv': 'Login - Ingreso a Alegra TPV',
      'login-pv': 'Login - Ingreso a Alegra Sistema Punto de Venta',
    },
  },
  default: {
    default: 'Alegra Software Contable',
    routes: {
      'request-password': 'Reiniciar contraseña',
      'change-password': 'Cambiar contraseña',
      'magic-link-session': 'Login - Alegra Software Contable',
      'agent-access': 'Login - Alegra Software Contable',
      'magic-link-error': 'Login - Alegra Software Contable',
    },
  },
}
